module.exports = __webpack_public_path__ + "static/media/afiliaciones-nuevas.c42f26df.svg";